import { render, staticRenderFns } from "./DroppableField.vue?vue&type=template&id=350de1f6&scoped=true"
import script from "./DroppableField.vue?vue&type=script&lang=js"
export * from "./DroppableField.vue?vue&type=script&lang=js"
import style0 from "./DroppableField.vue?vue&type=style&index=0&id=350de1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350de1f6",
  null
  
)

export default component.exports